import React, { useEffect } from "react";
import moment from "moment";

/** The card's date inputs (also the Tasks view's due dates). */
export const dateInputClasses =
  "border rounded-md p-1 text-sm bg-gray-100 focus:bg-white focus:outline-none focus:ring-1 focus:ring-gray-300";

export function DateRangeSelector({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  allowFutureDates = false,
}: {
  startDate: Date;
  endDate: Date;
  setStartDate: (d: Date) => void;
  setEndDate: (d: Date) => void;
  allowFutureDates?: boolean;
}) {
  // Enforce constraints
  useEffect(() => {
    if (moment(startDate).isAfter(moment(endDate))) {
      setStartDate(moment(endDate).subtract(1, "day").toDate());
    }

    if (!allowFutureDates) {
      const now = moment();
      if (moment(endDate).isAfter(now)) {
        setEndDate(now.toDate());
      }
    }
  }, [startDate, endDate, setStartDate, setEndDate, allowFutureDates]);

  const onStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = moment(e.target.value).startOf("day").toDate();
    if (!isNaN(val.getTime())) {
      if (!allowFutureDates && moment(val).isAfter(moment().endOf("day"))) {
        setStartDate(moment().startOf("day").toDate());
      } else {
        setStartDate(val);
      }
    }
  };

  const onEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = moment(e.target.value).endOf("day").toDate();
    if (!isNaN(val.getTime())) {
      if (!allowFutureDates && moment(val).isAfter(moment().endOf("day"))) {
        setEndDate(moment().endOf("day").toDate());
      } else {
        setEndDate(val);
      }
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium">From:</label>
      <input
        type="date"
        className={dateInputClasses}
        value={moment(startDate).format("YYYY-MM-DD")}
        onChange={onStartChange}
        max={allowFutureDates ? undefined : moment().format("YYYY-MM-DD")}
      />

      <label className="text-sm font-medium">To:</label>
      <input
        type="date"
        className={dateInputClasses}
        value={moment(endDate).format("YYYY-MM-DD")}
        onChange={onEndChange}
        max={allowFutureDates ? undefined : moment().format("YYYY-MM-DD")}
      />
    </div>
  );
}
